import { render, staticRenderFns } from "./ServiceTimeSetting.vue?vue&type=template&id=5b53f273&"
import script from "./ServiceTimeSetting.vue?vue&type=script&lang=ts&"
export * from "./ServiceTimeSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports